'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineTextArea = require('./components/InlineTextArea.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineTextArea).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-text-area/lib/index.js
// module id = 1016
// module chunks = 0